/**
 * 債権者の CSV・一覧表 PDF・宛名ラベル PDF の取得 (`hooks/useExportCreditors*.ts`) のトースト — 日本語 (正本)。
 * phase 2 の slice p2-06 (admin-english-toggle-20260924)。
 *
 * **中身 (CSV の列名・債権者一覧表・宛名ラベル) は裁判所・郵送用なので日本語のまま** (BE が作る)。
 * ここにはトーストの文言だけを置く。BE が返す文言 (件数上限の案内など) はデータなので訳さない。
 *
 * 債権者タブの名前空間 (`creditors`) と分けているのは、`useExportCreditorsCsv.ts` が通知の hook
 * (main chunk) から `parseContentDispositionFilename` のために import されていて、同じ名前空間に置くと
 * 債権者タブの辞書全体が main chunk に入るため (この名前空間は数百 byte)。
 */
export const creditorExportsJa = {
  csvFailed: 'CSV 出力に失敗しました',
  csvFailedStatus: 'CSV 出力に失敗しました ({status})',
  csvDone: 'CSV をダウンロードしました',
  pdfFailedStatus: 'PDF 出力に失敗しました ({status})',
  pdfDone: 'PDF をダウンロードしました',
  pdfDownloadFailed: 'PDF をダウンロードできませんでした。時間をおいて再度お試しください。',
  labelPdfFailedStatus: '宛名ラベルPDF出力に失敗しました ({status})',
  labelPdfDone: '宛名ラベルPDFをダウンロードしました。',
  labelPdfDownloadFailed:
    '宛名ラベルPDFをダウンロードできませんでした。時間をおいて再度お試しください。',
} as const;
